import { useState } from "react";
import { FaCrown, FaLock } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import SettingsModal from "./SettingsModal";

/**
 * Prikazuje upozorenje da je free korisnik dosegao limit,
 * s CTA koji otvara SettingsModal na subscription tabu.
 *
 * Props:
 * - reason: "guest" | "table"
 * - currentCount: number (trenutan broj)
 * - limit: number (free limit)
 */

const LIMITS = { guest: 50, table: 10 };

const UpgradePrompt = ({ reason, currentCount, limit, otherCount, setActiveForm }) => {
    const otherReason = reason === "guest" ? "table" : "guest";
    const otherLimit = LIMITS[otherReason];

    const { t } = useTranslation();
    const [showSettings, setShowSettings] = useState(false);

    const titleKey = reason === "guest" ? "upgradeGuestLimitTitle" : "upgradeTableLimitTitle";
    const descKey = reason === "guest" ? "upgradeGuestLimitDesc" : "upgradeTableLimitDesc";

    return (
        <>
            <div className="mb-7 rounded-2xl border-2 border-rose-300 bg-gradient-to-br from-rose-50 via-pink-50 to-cyan-50 shadow-md overflow-hidden">
                <div className="px-5 py-4 flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-rose-500 to-pink-600 flex items-center justify-center flex-shrink-0 shadow-lg shadow-rose-500/30">
                        <FaCrown className="text-white text-xl" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1">
                            <FaLock className="text-rose-600 text-sm" />
                            <h3 className="font-semibold text-gray-900 text-lg">
                                {t(titleKey, { count: limit })}
                            </h3>
                        </div>
                        <p className="text-sm text-gray-700 mb-3">
                            {t(descKey, { current: currentCount, limit })}
                        </p>
                        <button
                            type="button"
                            onClick={() => setShowSettings(true)}
                            className="inline-flex items-center gap-2 bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white px-5 py-2.5 rounded-xl font-semibold shadow-lg shadow-rose-500/30 transition-all"
                        >
                            <FaCrown className="text-sm" />
                            {t("upgradeNow", "Nadogradi")}
                        </button>
                        {/* nakon upgrade buttona */}
                        {reason === "guest" && otherCount < otherLimit && setActiveForm && (
                            <p className="text-sm text-gray-600 mt-3">
                                Još uvijek možeš besplatno dodati stolove ({otherCount}/{otherLimit}).
                                <button
                                    type="button"
                                    onClick={setActiveForm}
                                    className="ml-1 text-blue-600 hover:text-blue-800 font-semibold underline"
                                >
                                    Dodaj stol →
                                </button>
                            </p>
                        )}

                        {reason === "table" && otherCount < otherLimit && setActiveForm && (
                            <p className="text-sm text-gray-600 mt-3">
                                Još uvijek možeš besplatno dodati goste ({otherCount}/{otherLimit}).
                                <button
                                    type="button"
                                    onClick={setActiveForm}
                                    className="ml-1 text-blue-600 hover:text-blue-800 font-semibold underline"
                                >
                                    Dodaj gosta →
                                </button>
                            </p>
                        )}
                    </div>
                </div>
            </div>

            {showSettings && (
                <SettingsModal
                    onClose={() => setShowSettings(false)}
                    initialTab="subscription"
                />
            )}
        </>
    );
};

export default UpgradePrompt;
